import React from "react"
import CloudUploadIcon from "@material-ui/icons/CloudUpload"
import AssignmentIcon from "@material-ui/icons/Assignment"
import TrendingUpIcon from "@material-ui/icons/TrendingUp"
import LanguageIcon from "@material-ui/icons/Language"

const MainIcon = ({iconRef, classStyle}) => {
  switch (iconRef) {
    case ("CloudUpload"):
      return (<CloudUploadIcon className={classStyle}/>)
    case ("Assignment"):
      return (<AssignmentIcon className={classStyle}/>)
    case ("TrendingUp"):
      return (<TrendingUpIcon className={classStyle}/>)
    case ("Language"):
      return (<LanguageIcon className={classStyle}/>)
    default:
      return (<AssignmentIcon className={classStyle}/>)
  }
}

export default MainIcon